import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "foreign-trade-text" }
const _hoisted_2 = {
  key: 0,
  class: "foreign-trade-text__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInitLoadedData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paragraphCount, (index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "foreign-trade-text__paragraph"
            }, [
              _renderSlot(_ctx.$slots, _ctx.getParagraphSlotName(index), {}, undefined, true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["foreign-trade-text__loader", {
        'foreign-trade-text__loader--overlay': _ctx.isInitLoadedData,
      }])
        }, [
          _createVNode(_component_Loader)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}